import { withInstall } from '../../../utils/with-install'
import MassMarks from './MassMarks.vue'

export const ElAmapMassMarks = withInstall(MassMarks)
export default ElAmapMassMarks
